import React from "react";
import PublicLayout from "../shell/PublicLayout";
import ContinueZone from "../home/ContinueZone";
import RhythmRow from "../home/RhythmRow";
import ExploreShelves from "../home/ExploreShelves";
import SupportBand from "../home/SupportBand";

/*
 * Redesigned homepage — zones per brief §6.3 / Homepage reference:
 * 1 header (PublicLayout) · 2 Continue / signed-out hero · 3 rhythm row ·
 * 4 explore shelves · 5 newsletter + Chai Club · mini-player (RootShell).
 */

export default function HomePage() {
  return (
    <PublicLayout>
      <ContinueZone />
      <RhythmRow />
      <ExploreShelves />
      <SupportBand />
    </PublicLayout>
  );
}
